import Button from "./../ui/Button";
import FormGroup from "./../ui/FormGroup";
import Loader from "../ui/Loader";
import React from "react";
import isLoadingSelector from "../../../state/selectors/ClientSelectors/isLoadingSelector";
import { useSelector } from "react-redux";

const ButtonSubmit = () => {
    const isLoading = useSelector((state: Store) => isLoadingSelector(state));
    return (
        <FormGroup alignRight={true}>
            <Button isLoading={isLoading} uppercase shadow primary type="submit">
                Login
                {isLoading && <Loader light />}
            </Button>
        </FormGroup>
    );
};

export default ButtonSubmit;
